/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Button, Modal, NoteBox } from '../../../components';
import './index.css';
import EmailLoading from './EmailLoading.gif';
import PhoneLoading from './PhoneLoading.gif';
import emailSuccessIcon from './EmailSuccessIcon.svg';
import phoneSuccessIcon from './PhoneSuccessIcon.svg';
import emailExpiredIcon from './EmailExpiredIcon.svg';
import phoneExpiredIcon from './PhoneExpiredIcon.svg';
import { StatusType } from '../types';

type ModernPopupProps = {
  type: 'email' | 'phone';
  updatedValue: string;
  status: StatusType;
  resendLink: () => void;
  updateStatus: (it: StatusType) => void;
  showModal: boolean;
  setShowModal: (it: boolean) => void;
};

export default ({
  type = 'email',
  status,
  resendLink,
  updateStatus,
  updatedValue,
  showModal,
  setShowModal,
}: ModernPopupProps) => {
  const { t } = useTranslation();
  const ns = 'validation-modal';
  const dispatch = useDispatch();

  const validationProperty = type === 'email' ? 'email' : 'SMS';

  const validationPropertyUp = type === 'email' ? 'Email' : 'SMS';

  const refreshStatus = () => {
    updateStatus('info');
    resendLink();
    dispatch({
      type: 'OPEN_TOASTER',
      payload: {
        toasterTitle: t('validationModal.toasterTitle', { validationProperty }),
        toasterMessage: t('validationModal.toasterMessage', {
          validationProperty,
        }),
        toasterType: 'success',
        toasterVisible: true,
        toasterDismiss: null,
      },
    });
  };

  const subTitleMap: Record<string, string> = {
    info: t('validationModal.subTitleInfo', {
      validationProperty,
      updatedValue,
    }),
    warning: t('validationModal.subTitleWarning', { validationProperty }),
    success: t('validationModal.subTitleSuccess', {
      validationProperty:
        validationProperty === 'SMS' ? 'Phone number' : validationProperty,
    }),
  };

  const titleMap: Record<string, string> = {
    info: t('validationModal.titleInfo', { validationProperty }),
    warning: t('validationModal.titleWarning', { validationProperty }),
    success: t('validationModal.titleSuccess', {
      validationPropertyUp:
        validationPropertyUp === 'SMS' ? 'Phone number' : validationPropertyUp,
    }),
  };
  const badgeContentMap: Record<string, string | React.ReactNode> = {
    info: t('validationModal.badgeInfo', { validationProperty }),
    warning: (
      <div>
        {t('validationModal.badgeWarning', { validationProperty })}
        <div style={{ textDecoration: 'underline' }} onClick={refreshStatus}>
          {t('validationModal.badgeWarningResend', { validationProperty })}
        </div>
      </div>
    ),
    success: t('validationModal.badgeSuccess', { validationPropertyUp }),
  };

  return (
    <Modal
      isOutsideClickClose
      className="store-action-modal"
      isVisible={showModal}
      onClose={() => {
        setShowModal(false);
      }}
    >
      <div className={`${ns}__header`}>
        <h2>{titleMap[status]}</h2>
        <p>{subTitleMap[status]}</p>
      </div>
      <div className={`${ns}__content`}>
        {status === 'info' && (
          <img
            src={type === 'email' ? EmailLoading : PhoneLoading}
            style={{ width: '95px' }}
            alt="loading..."
          />
        )}
        {status === 'success' && (
          <img
            src={type === 'email' ? emailSuccessIcon : phoneSuccessIcon}
            style={{ width: '95px' }}
            alt="success"
          />
        )}
        {status === 'warning' && (
          <img
            src={type === 'email' ? emailExpiredIcon : phoneExpiredIcon}
            style={{ width: '95px' }}
            alt="success"
          />
        )}
      </div>

      <div className={`${ns}__modal-footer`}>
        {status !== 'success' && (
          <NoteBox status={status}>{badgeContentMap[status]}</NoteBox>
        )}
        {status === 'success' && (
          <div className={`${ns}__button-wrapper`}>
            <Button
              extraClass={`${ns}__button btn blue`}
              onClick={() => setShowModal(false)}
            >
              {t('validationModal.successButton')}
            </Button>
          </div>
        )}
      </div>
    </Modal>
  );
};
